import React from 'react'
import T from 'prop-types'
import ErrorPage from 'components/ErrorPage/ErrorPage'

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    const { onError } = this.props
    onError(error, info)

    // Display fallback UI
    this.setState({ hasError: true })
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info)
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      // You can render any custom fallback UI
      return <ErrorPage />
    }
    return children
  }
}

ErrorBoundary.propTypes = {
  onError: T.func,
  children: T.element,
}

ErrorBoundary.defaultProps = {
  onError: () => {},
  children: null,
}

export default ErrorBoundary
